import React from 'react';
import { AppContextType, withAppContext } from 'context/AppContext';
import { PrismicExternalLink } from 'components/Slices/types';
import { SegmentService } from 'analytics';
import { PrismicLinkProps } from 'components/PrismicLink';

type ExternalLinkProps = PrismicLinkProps & {
    link: PrismicExternalLink;
    context?: AppContextType;
};

const ExternalLinkComponent = (props: ExternalLinkProps) => {
    /**
     * Sends the "Link Followed" event to Segment
     * @param {React.MouseEvent<HTMLAnchorElement>} event : the click event
     */
    const followLink = (event: React.MouseEvent<HTMLAnchorElement>): void => {
        const url = event.currentTarget.getAttribute('href') || '';
        const { target } = event.currentTarget;

        if (!url) {
            return;
        }

        if (target && target === '_blank') {
            SegmentService.trackLinkFollowed({ 'L - Destination Link': url }, props.slice);
        } else {
            event.preventDefault();
            SegmentService.trackLinkFollowed({ 'L - Destination Link': url }, props.slice).then(() => {
                window.top.location.assign(url);
            });
        }
    };

    const { label, link, className, children } = props;

    return (
        <a href={link.url} target={link.target || '_blank'} rel="noopener" className={className} onClick={followLink}>
            {label || children}
        </a>
    );
};

const ExternalLink = withAppContext(ExternalLinkComponent);

export { ExternalLink, ExternalLinkComponent, ExternalLinkProps };
